module.exports = ".modal-dialog {\n  width: 75%;\n  max-height: 95%;\n  max-width: none;\n  overflow-y: auto; }\n\n.badge {\n  font-size: 100% !important;\n  text-align: center; }\n\n.badge.badge-success {\n  position: inherit;\n  left: 39px;\n  display: inline-block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-billing-list/bc-billing-list-integral/comment-modal/comment-modal.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-billing-list/bc-billing-list-integral/comment-modal/comment-modal.component.scss
// module chunks = main